import { t } from '../services/language-manager';
import { LanguagePicker } from './LanguagePicker';
import { BackButton } from './BackButton';
import { ConversationActionsSection } from './ConversationActionsSection';
import logo from '../assets/mediabriz-logo-svg-400px.svg';

interface ConversationActionsPageProps {
  genesysOrgId: string;
  genesysRegion: string;
  /** Insights dashboard URL for the Recent deliveries footer link. */
  insightsUrl?: string;
  onBack: () => void;
  /** Dev preview: sample action, no API. */
  preview?: boolean;
}

/** Standalone Conversation Actions surface. Opened from Landing, not from Settings. */
export function ConversationActionsPage({
  genesysOrgId,
  genesysRegion,
  insightsUrl,
  onBack,
  preview = false,
}: ConversationActionsPageProps) {
  return (
    <div className="card settings-page">
      <div className="settings-page__nav">
        <BackButton onClick={onBack} />
        <LanguagePicker />
      </div>
      <img src={logo} alt="Mediabriz" className="settings-page__logo" />
      <h2 className="settings-page__title">{t('settings-actions-title')}</h2>
      <p className="settings-page__intro">{t('settings-actions-intro')}</p>

      <ConversationActionsSection
        genesysOrgId={genesysOrgId}
        genesysRegion={genesysRegion}
        insightsUrl={insightsUrl}
        preview={preview}
      />
    </div>
  );
}
